import { type Repub } from '@cx-modules/types';

import { getUrlWithRepub } from '../utils/getUrlWithRepub';

export const HomeIconLink = ({ baseUrl, repub }: { baseUrl: string; repub: Repub }) => {
  const finalUrl = getUrlWithRepub(baseUrl, repub);

  return (
    <a aria-label="Home" href={finalUrl}>
      <svg fill="none" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="25" r="24" stroke="white" stroke-width="2" />
        <path
          d="M25.499 12.5C25.981 12.5 26.4315 12.6872 26.7725 13.0283L36.9707 23.2256L36.9717 23.2266V23.2275H36.9727C37.6727 23.9297 37.6723 25.0717 36.9717 25.7734C36.6303 26.1147 36.1791 26.3018 35.6973 26.3018H34.8203V34.3066C34.8203 35.5154 33.8362 36.4998 32.627 36.5H28.6367C28.5084 36.4999 28.4043 36.3959 28.4043 36.2676V30.3838C28.4043 29.4301 27.6295 28.6554 26.6758 28.6553H24.3223C23.3684 28.6553 22.5938 29.43 22.5938 30.3838V36.2676C22.5938 36.3958 22.4894 36.4998 22.3613 36.5H18.3711C17.1618 36.5 16.1777 35.5155 16.1777 34.3066V26.3018H15.2705C15.2628 26.3017 15.2551 26.3015 15.248 26.3008L15.2354 26.2998L15.2217 26.2988L15.0527 26.2842C14.72 26.2389 14.4097 26.1022 14.1514 25.8877L14.0264 25.7734C13.3263 25.0733 13.3241 23.933 14.0215 23.2305C14.026 23.2259 14.0309 23.222 14.0322 23.2207L24.2246 13.0273C24.5657 12.6863 25.017 12.5 25.499 12.5Z"
          fill="white"
          stroke="white"
        />
      </svg>
    </a>
  );
};
